module.exports = __webpack_public_path__ + "img/logo_ko_w.a2dcf4d4.svg";